<template>
  <div class="upload-image">
    <div class="upload-button" role="button" tabindex="0" @click.stop="onUpload" @keyup.enter.stop="onUpload">
      <div v-if="error" class="error ri-bold-label">{{ error }}</div>
      <img v-else-if="selectedImage" :src="selectedImage" class="upload-image-preview" alt="התמונה שנבחרה"/>
      <img v-else-if="existingImage" :src="require('../assets/upload-image-exists.svg')" alt="תמונה קיימת"/>
      <div v-else class="flex-column align-center">
        <action-icon v-if="!loading" :action-type="ACTION_TYPE.UPLOAD_IMAGE" @click="onUpload"/>
        <div class="ri-bold-body margin-top-xs">{{ buttonTextWithLoading }}</div>
      </div>
    </div>
    <div v-if="!hasImage && !error" class="ri-label margin-top-xs margin-right-xxs">
      {{ bottomText }}
    </div>
    <div v-else class="uploaded-image-buttons">
      <action-icon v-if="!loading" :action-type="ACTION_TYPE.UPLOAD_IMAGE" @click="onUpload"  @keyup.enter.stop="onUpload"/>
      <div v-if="hasImage" class="ri-bold-label success">הועלה בהצלחה!</div>
      <action-icon v-if="hasImage" :action-type="ACTION_TYPE.DELETE" @click="onDelete" @keyup.enter.stop="onDelete"/>
    </div>
    <input type="file" :accept="accept" ref="imageUpload" style="display: none;" alt="צילום / העלאת תמונה" @change="onSelection" @click.stop/>
  </div>
</template>

<script>
import ActionIcon from './ActionIcon/ActionIcon';
import { ACTION_TYPE } from './ActionIcon/ActionIcon.consts';

export default {
  name: 'UploadImage',
  components: {
    ActionIcon,
  },
  props: {
    buttonText: {
      type: String,
      default: 'צילום / העלאת תמונה',
    },
    bottomText: {
      type: String,
      default: 'קבצים מסוג jpeg/png/gif/pdf, עד 20MB',
    },
    accept: {
      type: String,
      default: 'image/*, application/pdf',
    },
    existingImage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ACTION_TYPE,
      selectedImage: null,
      error: false,
      loading: false,
    };
  },
  computed: {
    buttonTextWithLoading() {
      return this.loading ? 'הקובץ עולה...' : this.buttonText;
    },
    hasImage() {
      return this.existingImage || this.selectedImage;
    },
  },
  methods: {
    onUpload() {
      this.$emit('click');
      this.$refs.imageUpload.click();
    },
    onSelection() {
      this.loading = true;
      const file = this.$refs.imageUpload?.files?.[0];
      if (!file) {
        this.loading = false;
        return;
      }
      const sizeInMb = file.size / 1024 / 1024;
      if (sizeInMb > 5) {
        this.error = 'התמונה גדולה מ-5MB';
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        this.error = null;
        this.selectedImage = reader.result;
        this.loading = false;
      };
      reader.onerror = e => {
        this.selectedImage = null;
        this.error = 'משהו קרה, וההעלאה לא הצליחה, כדאי לנסות שוב';
        this.loading = false;
      };
      reader.readAsDataURL(file);
      this.$emit('select', file);
    },
    onDelete() {
      this.$emit('delete');
      this.selectedImage = null;
      this.$refs.imageUpload.value = null;
    },
  },
};
</script>

<style scoped lang="scss">
@import '../scss/riseup-colors';
@import '../scss/border-radius';
@import '../scss/spacings';

.upload-image {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  .upload-button {
    width: 100%;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: $card-border-radius;
    height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: $riseup_blue;
    cursor: pointer;
    box-sizing: border-box;
    overflow: hidden;

    .error {
      color: $riseup_danger_red;
    }
  }

  .upload-image-preview {
    max-height: 200px;
    max-width: 100%;
  }

  .uploaded-image-buttons {
    color: $riseup_blue;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
    box-sizing: border-box;
    padding: $ri-spacing-xs;
    .success {
      color: $riseup_green;
    }
  }
}
</style>
